import React, { useState, useEffect } from "react";
import { useState as useAppState } from "../state/useState";
import { order } from "../service/RechargeService";
import { redirectTo } from "../state/action";
import { checkStatus } from "../service/RechargeService";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from 'react-loader-spinner';

const New = 1;
const Order = 2;
const Canceled = 3;
const Ordered = 4;
const Cancel = 5;
const Paid = 6;
const Delivered = 7;
const Refunded = 8;
const Processing = 9;

export function Checkstatus({ history, uuid }) {


    let [state, dispatch] = useAppState();
    let [loading, setLoading] = useState(false);
    let [loaded, setLoaded] = useState(false);
    let [order, setOrder] = useState(null);
    let [start, setStart] = useState(new Date());

    function shouldCreateTimer(uuid) {
        let now = new Date();
        if (start.getTime() + 50000 < now.getTime()) {
            //console.log("timeouted");
            history.push("/statustimeout/" + uuid);
        } else {
            setTimeout(() => timerCheckStatus(uuid), 2000)
        }
    }

    function timerCheckStatus(uuid) {
        checkStatus(uuid)
            .then(response => {
                //console.log("response ", response);
                if (response.uuid && response.status != Order && response.status != Ordered && response.status != Processing) {
                    setLoaded(true);
                    setLoading(false);
                    history.push("/status/" + response.uuid + "/" + response.status + "/" + response.voucherCode + "/" + response.email);
                } else {
                    shouldCreateTimer(uuid);
                }
            })
            .catch(error => {
                shouldCreateTimer(uuid);
            })
            ;
    }

    useEffect(() => {
        if (!loading && !loaded) {
            setStart(new Date());
            setTimeout(() => timerCheckStatus(uuid), 0);
            setLoading(true);

        }
    }, []);

    function onSubmit(value) {
        value.preventDefault();

        order(state.selectedOperator.index, state.phoneNumber, state.amount)
            .then(result => {
                console.log("result", result);
                if (result.success) {
                    dispatch(redirectTo(result.redirectTo));
                    history.push("/redirect")
                }
                return result;
            })
            .catch(error => {
                console.log("error", error);
            })
    }


    return <>
        <div class="page_title2">
            <div class="container">

                <div class="title"><h1>Obrada transakcije...</h1></div>
            </div>
        </div>


        <div class="clearfix"></div>

        <div class="container">

            <div class="content_fullwidth">

                <div class="reg_form">
                    <Loader
                        type="Puff"
                        color="#EC258F"
                        height="70"
                        width="70"
                    />
                    <p><h3 class="nocaps">U toku je obrada transakcije, molim Vas sačekajte.</h3>
                    </p>
                    <blockquote><p>Transakcija: <strong>{uuid}</strong></p></blockquote>
                    <blockquote><p>Status: <strong>Obrada</strong></p></blockquote>


                    <p></p>


                    <p></p>
                    <br />
                    <br />
                    <br />
                    <br />

                </div>


            </div>

        </div>

        <div class="clearfix margin_top7"></div>

        <div class="clearfix"></div>

    </>

}
